module.exports = __webpack_public_path__ + "static/media/bfile-currency.4ab4e682.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-currency.svg
// module id = 572
// module chunks = 0